import { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface Props {
  children: ReactNode
  variant?: "default" | "yellow"
}

export default function InfoBubble({ children, variant = "default" }: Props) {
  return (
    <div
      className={twMerge(
        "mb-4 w-full rounded-2xl p-4 text-center",
        variant === "default"
          ? "bg-gray-50 text-gray-500"
          : "bg-yellow-50 text-yellow-800",
      )}
    >
      <p className="text-sm">{children}</p>
    </div>
  )
}
